<div *ngIf="prikaziStranicu" class="container-fluid">
  <h2 class="content-block meduskladisnica-naslov">MEĐUSKLADIŠNICA za mrvice</h2>

  <div class="content-block dnevniPlanWrapper">
    <div class="selectDates">
      <div class="odabirDatuma">
        <label>Datum od:</label>
        <dx-date-box
          [(value)]="datumOd"
          [(max)]="datumDo"
          pickerType="calendar"
          displayFormat='dd.MM.yyyy.'
          width="200"
          (onValueChanged)="onValueChangedDatumOd($event)"
        >
        </dx-date-box>
      </div>
      <div class="odabirDatuma">
        <label>Datum do:</label>
        <dx-date-box
          [(value)]="datumDo"
          [(min)]="datumOd"
          pickerType="calendar"
          displayFormat='dd.MM.yyyy.'
          width="200"
          (onValueChanged)="onValueChangedDatumDo($event)"
        >
        </dx-date-box>
      </div>
      <div class="odabirDatuma" style="margin-left: 30px">
        <label>Odabir skladišta:</label>
        <dx-select-box
          [items]="poslovnice"
          [(value)]="id_odabranoSkladiste"
          valueExpr="idposlovnica"
          displayExpr="sifrainaziv"
          [showClearButton]="true"
          [searchEnabled]="true"
          [width]="480"
          (onValueChanged)="promjenaSkladista($event)"
        >
        </dx-select-box>
      </div>
      <div class="odabirDatuma">
        <dx-button
          class="btn_trazi"
          [disabled]="id_odabranoSkladiste == undefined || disableGumb"
          stylingMode="contained"
          text="Pretraži"
          type="success"
          [width]="120"
          (onClick)="pretrazi()">
        </dx-button>
      </div>
    </div>

    <!-- "problem" pravilo to što add button bude iza Pretraži... (zbog direction: rtl;) pa je dodana klasa pregledIzdatnica u style.css -->
                        <!-- dnevniPlan -->
    <div class="customTable pregledIzdatnica">
      <dx-data-grid
        id="tablicaDostavnica"
        [dataSource]="meduskladisnicePopis"
        [wordWrapEnabled]="true"
        noDataText="{{ poruka }}"
        keyExpr="pz_id"
        [showBorders]="false"
        [columnAutoWidth]="true"
        [columnMinWidth]="60"
        (onToolbarPreparing)="onToolbarPreparing($event)"
        [showColumnLines]="true"
        (onSelectionChanged)="onSelectionChanged($event)"
        (onRowClick)="onRowClick($event)"
        (onRowInserted)="dodajZaglavlje($event)"
        (onRowUpdated)="urediZaglavlje($event)"

        (onRowRemoved)="obrisiDokument($event)"
        (onCellPrepared)="onCellPrepared($event)"
        (onInitNewRow)="onInitNewRow($event)"
        (onEditingStart)="onEditingStart($event)"
      >
        <div *dxTemplate="let data of 'naslovTablice'" class="grid-wrapper">
          <div class="naslov">
            <h2 class="mb-0" style="padding-right: 30px">Popis međuskladišnica</h2>
          </div>
        </div>

        <dxo-header-filter [visible]="true"></dxo-header-filter>

        <dxo-scrolling
          columnRenderingMode="virtual"
          [showScrollbar]="'always'"
        ></dxo-scrolling>

        <dxo-search-panel
          [visible]="true"
          [width]="210"
          placeholder="Pretraži..."
        >
        </dxo-search-panel>

        <dxo-paging [enabled]="true" [pageSize]="10"></dxo-paging>

        <dxo-pager
          [showPageSizeSelector]="true"
          [allowedPageSizes]="[10, 20, 30]"
          [showInfo]="true"
        >
        </dxo-pager>

        <dxo-selection mode="single"></dxo-selection>

        <dxo-editing
          mode="popup"
          [allowAdding]="true"
          [allowUpdating]="true"
          [allowDeleting]="true">

          <dxo-popup
            [disabled]="pravaZaTrenutniPogled != 2"
            [onShowing]="onShowing"
            [showTitle]="true"
            title=""
            [maxWidth]="500"
            [height]="'auto'">
          </dxo-popup>

          <dxo-form [colCount]="1">
            <dxi-item
              dataField="pz_datum"
              editorType="dxDateBox" 
              [editorOptions]="{showClearButton: 'true'}"
            ></dxi-item>
            
            <dxi-item
              dataField="poslovnica_po_id"
              editorType="dxSelectBox"
              [editorOptions]="{
                items: poslovniceOtpreme,
                value: 'idposlovnica',
                valueExpr: 'idposlovnica',
                displayExpr: 'sifrainaziv',
                searchEnabled: 'true',
                searchExpr: ['po_sifra', 'po_naziv']
              }"
            ></dxi-item>

            <dxi-item
              dataField="poslovnica_po_id2"
              editorType="dxSelectBox"
              [editorOptions]="{
                items: poslovnicePrijema,
                value: 'idposlovnica',
                valueExpr: 'idposlovnica',
                displayExpr: 'sifrainaziv',
                searchEnabled: 'true',
                searchExpr: ['po_sifra', 'po_naziv']
              }"
            ></dxi-item>

          </dxo-form>
        </dxo-editing>

        <dxi-column
          dataField="pz_broj"
          caption="Broj dokumenta"
          [width]="120"
          alignment="center"
          [allowEditing]="false"
          [calculateSortValue]="calculateSortValue"
        ></dxi-column>

        <dxi-column
          dataField="pz_brojvezni"
          caption="Interna primka"
          [width]="140"
          alignment="center"
        ></dxi-column>

        <dxi-column
          dataField="pz_datum"
          dataType="date"
          caption="Datum"
          [width]="150"
          [allowEditing]="dozvoliUredivanje"
          alignment="left"
        ></dxi-column>

        <dxi-column
          dataField="poslovnica_po_id"
          caption="Skladište otpreme"
          [visible]="false"
          [formItem]="{ visible: true }"
          [allowEditing]="dozvoliUredivanje"
        ></dxi-column>

        <dxi-column
          dataField="po_naziv"
          caption="Skladište otpreme"
          [minWidth]="180"
        ></dxi-column>

        <dxi-column
          dataField="poslovnica_po_id2"
          caption="Skladište prijema"
          [visible]="false"
          [formItem]="{ visible: true }"
          [allowEditing]="dozvoliUredivanje"
        ></dxi-column>

        <dxi-column
          dataField="po_naziv2"
          caption="Skladište prijema"
          [minWidth]="180"
        ></dxi-column>

        <dxi-column
          dataField="name"
          caption="Kreirao"
          [minWidth]="150"
        ></dxi-column>

        <dxi-column
          dataField="pz_danisat"
          dataType="datetime"
          caption="Datum i vrijeme kreiranja"
          [width]="130"
          alignment="left"
        ></dxi-column>

        <dxi-column
          dataField="pz_napomena"
          caption="Napomena"
        ></dxi-column>

        <dxi-column
          dataField="partner_pa_id_vezni"
          caption="Prijevoznik"
          [allowEditing]="dozvoliUredivanje"
          [visible]="false"
        ></dxi-column>

        <dxi-column
          dataField="pz_prijevoznik_naziv"
          caption="Prijevoznik"
          [minWidth]="180"
        ></dxi-column>

        <dxi-column
          dataField="pz_registracijavozila"
          caption="Registracija vozila"
          [allowEditing]="dozvoliUredivanje"
          [width]="125"
        ></dxi-column>

        <dxi-column
          dataField="pz_rednibrojslepera"
          caption="Broj šlepera"
          [width]="95"
          alignment="center"
        ></dxi-column>

        <!-- zbog daleko sporijeg upita (20 i više puta od standardnog) da bi dohvatili i prikazali brojpaleta izbačeno -->
        <!--
        <dxi-column
          dataField="brojpaleta"
          caption="Broj paleta"
          [width]="70"
          alignment="center"
          [allowFiltering]="false"
        ></dxi-column>
        -->

        <dxi-column
          dataField="pz_vrijemeutovara"
          caption="Vrijeme utovara"
          [width]="90"
        ></dxi-column>

        <dxi-column
          dataField="pz_status"
          caption="Status"
          [width]="100"
          alignment="center"
        ></dxi-column>

        <dxi-column caption="PDF" cellTemplate="pdfFile" alignment="center" [fixed]="true" fixedPosition="right">
          <div *dxTemplate="let data of 'pdfFile'">
            <div *ngIf="data.data.pz_status === 'Z'">
              <dx-button
                icon="pdffile"
                (onClick)="pdfMeduskladisnica(data)"
                [disabled]="pravaZaTrenutniPogled != 2">
              </dx-button>
            </div>
          </div>
        </dxi-column>

        <dxi-column cellTemplate="zavrsi" alignment="center" [fixed]="true" fixedPosition="right">
          <div *dxTemplate="let data of 'zavrsi'">
            <div *ngIf="data.data.pz_status != 'S' && data.data.pz_status != 'Z'">
              <dx-button
                [disabled]="pravaZaTrenutniPogled != 2"
                text="Završi"
                (onClick)="zavrsiDokument(data)">
              </dx-button>
            </div>
            <br />
            <div *ngIf="data.data.pz_status === 'I' || data.data.pz_status === 'U'">
              <dx-button
                [disabled]="pravaZaTrenutniPogled != 2"
                text="Dodaj stavke palete"
                (onClick)="addPalletePopup()">
              </dx-button>
            </div>
          </div>
        </dxi-column>

        <!-- <dxi-column caption="Storniraj" cellTemplate="storniranje" alignment="center" [fixed]="true" fixedPosition="right">
          <div *dxTemplate="let data of 'storniranje'">
            <div *ngIf="data.data.pz_status === 'Z' && data.data.pz_program_kreiranja == 0">
              <dx-button [disabled]="pravaZaTrenutniPogled != 2" hint="Storniraj" icon="close" (onClick)="stornirajDokument(data)"></dx-button>
            </div>
          </div>
        </dxi-column> -->

        <dxi-column type="buttons" alignment="center" [fixed]="true" fixedPosition="right"></dxi-column>

        <dxo-master-detail
          [enabled]="false"
          template="detail"
        ></dxo-master-detail>

        <div *dxTemplate="let data of 'detail'">
          <div *ngIf="isLoading">Dohvaćanje podataka...</div>
          <div *ngIf="!isLoading">
            <div class="dokumentStavke">
              <dx-data-grid
                [dataSource]="stavke"
                [wordWrapEnabled]="true"
                [showColumnLines]="true"
                [showBorders]="true"
                (onRowUpdated)="urediStavku($event)"
                (onRowRemoved)="obrisiStavku($event)"
                [disabled]="pravaZaTrenutniPogled != 2"
              >
                <dxo-group-panel [visible]="true"></dxo-group-panel>

                <dxo-grouping #expand [autoExpandAll]="true"></dxo-grouping>

                <dxo-editing
                  *ngIf="data.data.pz_status !== 'S' && data.data.pz_status !== 'Z'"
                  mode="cell"
                  [allowUpdating]="true"
                  [allowDeleting]="true"
                ></dxo-editing>

                <dxi-column
                  dataField="ar_sifra"
                  caption="Šifra"
                  [width]="120"
                  [allowEditing]="false"
                ></dxi-column>

                <dxi-column
                  dataField="ar_naziv"
                  caption="Proizvod"
                  [width]="500"
                  [allowEditing]="false"
                ></dxi-column>

                <dxi-column
                  dataField="ar_lot"
                  caption="LOT"
                  [width]="120"
                  [allowEditing]="false"
                  [groupIndex]="0"
                ></dxi-column>

                <dxi-column
                  dataField="ps_izlaz"
                  caption="Izlaz"
                  [width]="120">
                  <dxo-format type="fixedPoint" [precision]="2"></dxo-format>
                </dxi-column>

                <dxi-column
                  dataField="ps_izlazc"
                  caption="Cijena"
                  [width]="120"
                  [allowEditing]="false">
                  <dxo-format type="fixedPoint" [precision]="5"></dxo-format>
                </dxi-column>

                <dxo-summary>
                  <dxi-group-item
                    column="ar_lot"
                    summaryType="count"
                    displayFormat="Ukupno paleta: {0}"
                  >
                  </dxi-group-item>
                </dxo-summary>

                <dxi-sort-by-group-summary-info
                  summaryItem="count"
                ></dxi-sort-by-group-summary-info>
              </dx-data-grid>
            </div>
          </div>
        </div>
        
      </dx-data-grid>
    </div>
  </div>
</div>


<!-- (onRowUpdated)="urediZaglavlje($event)" -->
<!-- POPUP ZA DODAVANJE PALETA -->
<dx-popup
  [width]="1000"
  [height]="'auto'"
  [showTitle]="true"
  title="Ručno upisivanje palete"
  [dragEnabled]="false"
  [showCloseButton]="true"
  [(visible)]="popupAddPalleteVisible"
  [closeOnOutsideClick]="false"
>
  <div class="popup-form-wrapper">
    <div class="floating-placeholder">
      <dx-select-box
        [dataSource]="sviArtikli_poslovnica"
        displayExpr="artiklsifranaziv"
        [(value)]="odabraniProizvod"
        placeholder="Proizvod"
        (onValueChanged)="onChangeProizvodId($event)"
        [searchEnabled]="true"
        [showClearButton]="true"
        required
      ></dx-select-box>
    </div>

    <div class="floating-placeholder">
      <dx-select-box
        [dataSource]="sviLotovi_artikla"
        displayExpr="ar_datum_ar_vazido_ar_lot_ar_lotstanje_spojeno"
        valueExpr="ar_lot"
        [(value)]="lotBroj"
        placeholder="LOT broj"
        (onValueChanged)="onChangeLot($event)"
        [searchEnabled]="true"
        [showClearButton]="true"
        required
      ></dx-select-box>
    </div>

    <div class="floating-placeholder">
      <dx-text-box
        placeholder="Količina"
        [value]="kolicina"
        (onValueChanged)="onChangeKolicina($event)"
        required
      ></dx-text-box>
    </div>

    <dx-button
      [width]="'auto'"
      [height]="'auto'"
      class="dodajButton"
      stylingMode="outlined"
      type="success"
      text="Dodaj"
      [disabled]="idProizvoda === '' || lotBroj === ''"
      (onClick)="dodajStavku()"
    >
    </dx-button>
  </div>
</dx-popup>